import { useContext, useRef, useState } from "react";
import { useForm } from "react-hook-form";

import { ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";
import trigger from "common/trigger";

import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import Img from "components/atoms/Img";
import ReCaptcha from "components/atoms/Recaptcha/index";

export const FormSend = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { openAlert } = useContext(ToastContext);
  const recaptchaRef = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onTalkClick = async () => {
    // eslint-disable-next-line no-undef
    await Tawk_API.toggle();
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();
      const newData = { ...data };

      newData.contact_from_id = 31;
      newData.client_id = GAUserID ? GAUserID : "";
      newData.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      // Axios
      //   .post(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/tax_tool`,
      //     NewData,
      //     {
      //       Headers: {
      //         "captcha-response": token,
      //       },
      //     }
      // )
      sendData({
        api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/tax_tool`,
        data: newData,
        token,
      })
        .then((res) => {
          trigger("contact_form", newData);
          if (res.state) {
            trigger("contact_form", data, "Belize Tax Mini Tool");
            openAlert(3000, "success");
            // CloseModal();
          } else {
            openAlert(3000, "error");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          openAlert(3000, "error");
          console.log(err);
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      <div className="row ml-0 mb-4 w-full justify-center">
        <form
          onSubmit={handleSubmit(onSubmit)}
          id="form-email"
          className="flex flex-col justify-center p-0 sm:flex-row"
        >
          <div className="col-12 flex justify-between rounded-full  border bg-white p-0 lg:col-7">
            <input
              {...register("email", {
                required: {
                  value: true,
                  message: "This field is required.",
                },
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "invalid email address",
                },
              })}
              className="form-control flex-auto rounded-full border-0 bg-white px-6 py-2 shadow-none placeholder:text-gray-400 focus:outline-none"
              placeholder="Enter your email"
            />
            <button
              type="submit"
              className="m-1 hidden h-10 w-10 items-center justify-center rounded-full bg-bbc-brand-500 leading-none sm:flex"
            >
              {isLoading ? (
                <span className="flex items-center pr-0">
                  <BiLoaderAlt className="w-9 animate-spin" size={20} />
                </span>
              ) : (
                <Img
                  src="/assets/icons/send-mail.svg"
                  width={24}
                  height={24}
                  alt="send"
                />
              )}
            </button>
          </div>
          <button
            type="submit"
            className="mt-2 flex h-10 items-center justify-center rounded-full bg-bbc-brand-500 py-2 font-semibold leading-[26px] text-white sm:hidden"
          >
            {isLoading ? (
              <span className="flex items-center pr-0">
                <BiLoaderAlt className="w-9 animate-spin" size={20} />
              </span>
            ) : (
              "Send Now"
            )}
          </button>
        </form>
        {errors && errors.email && (
          <p className="my-2 text-center text-sm tracking-[0.15px] text-red-500">
            {errors.email.message}
          </p>
        )}
      </div>
      <div className="mb-4 text-center">
        <span className="mb-2">Or </span>
        <button onClick={onTalkClick} className="text-bbc-primary">
          Talk to our expert
        </button>
      </div>
      <div>
        <ReCaptcha ref={recaptchaRef} className="flex justify-center" />
      </div>
    </>
  );
};
